import { setObjectTypes } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { getObjectType } from '@cas/utils/translationHelpers';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { ObjectTypeId } from '@dmc/ui';

const OBJECT_TYPE_IDS: number[] = Object.values(ObjectTypeId).filter(
  value => typeof value === 'number',
);

export const useObjectTypeOptions = (): DropdownItemProps<number>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return OBJECT_TYPE_IDS.map((objType: number) => {
      const stringValue = objType.toString();
      return {
        key: stringValue,
        value: objType,
        stringValue,
        label: t(getObjectType(t, objType)),
      };
    });
  }, [t]);
};

export const ObjectTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<number>
      filterName="objectTypes"
      label={label ?? t('ObjectType')}
      action={setObjectTypes}
      elementRef={elementRef}
      useItemsHook={useObjectTypeOptions}
    />
  );
};

export default ObjectTypesFilter;
